import { Room } from "./../../services/room";

export const state = {
  currentRoom: {},
  room: {}
};

export const mutations = {
  SET_ROOM(state, room) {
    state.currentRoom = room;
  },
  UNSET_ROOM(state) {
    state.currentRoom = {};
  }
};

export const getters = {
  getCurrentRoom(state) {
    return state.currentRoom;
  }
};

export const actions = {
  getRoomDetails({}, od) {
    return Room.detail(od);
  },

  selectRoom({ commit }, payload) {
    commit("SET_ROOM", payload);
  },

  clearSelectedRoom({ commit }) {
    commit("UNSET_ROOM");
  },

  createRoomV2({}, payload) {
    return Room.create(payload);
  },

  getRoomDetailsV2({}, id) {
    return Room.detailV2(id);
  }
};
